import Endpoints from 'constants/Endpoints';
import {RestRequestDELETE, RestRequestGET, RestRequestPOST, RestRequestPUT} from 'libs/RestRequest';
import reduxStore from 'redux/store'
import {SELECT_VALUE} from 'constants/VATItems';
import {addObjectResource, addObjectResources, clearResource, setResource, setSaveStatusDialog, setSaveStatusError, setSaveStatusLoading} from 'redux/actions'
import Tr from 'translations/Translations';
import VatType from 'constants/VatType';
import getObjectValue from "../libs/getObjectValue";
import moment from "libs/moment";

const clearResources = (resource) => {
    reduxStore.dispatch(clearResource(resource));
}

const getDealingsMatchingCriterion = async (demandId, critId) => {
    const res = await RestRequestGET(Endpoints.DEALINGS_WITH_CRITERION(demandId, critId))
    return res;
}


const getDealingsMatchingCriterionName = async (demandId, stageId, criteriumType, name) => {
    let params = {
        name
    }
    const res = await RestRequestGET(Endpoints.DEALINGS_MATCHING_CRITERION(demandId, stageId, criteriumType), {params});
    return res;
}

const _prepareIncomingDealing = (dealing) => {
    const {agreementRealizationDate, ...other} = dealing;

    const text = getObjectValue('agreementRealizationDate.text', dealing);
    const date = getObjectValue('agreementRealizationDate.date', dealing);
    return {
        ...other,
        termOption: text ? "text" : "date",
        termDate: date ? moment(date) : null,
        termDescription: text
    }
};

const getList = async (demandId) => {
    try {
        const res = await RestRequestGET(Endpoints.DEALINGS(demandId));

        const modRes = {
            ...res,
            dealings: res.dealings.map(x => _prepareIncomingDealing(x)),
        };


        reduxStore.dispatch(
            setResource('dealingsList', modRes)
        )
    } catch (error) {
        console.error(error)
    }
}

const get = async (demandId, dealingId) => {
    const {resources} = reduxStore.getState()
    const dealing = resources.dealing ? resources.dealing[dealingId] : undefined
    if (dealing) return;

    try {
        const res = await RestRequestGET(Endpoints.DEALINGS_SINGLE(demandId, dealingId));
        const modRes = _prepareIncomingDealing(res);
        reduxStore.dispatch(
            addObjectResource('dealing', dealingId, modRes)
        )
        return modRes;
    } catch (error) {
    }
}

const getFullList = async (demandId, dealingIds) => {

    const data = {
        items: dealingIds
    };

    const res = await RestRequestPOST(Endpoints.DEALINGS_LIST(demandId), data);
    const payload = {};
    res.forEach(item => {
        payload[item.identity] = _prepareIncomingDealing(item)
    });
    reduxStore.dispatch(
        addObjectResources('dealing', payload)
    );
    return payload;

}

const _formatSinglePartValues = (values) => {
    // eslint-disable-next-line
    const {
        _open,
        _edit,
        _touched,
        _load,
        amount,
        items,
        name,
        termOption,
        termDescription,
        termDate,
        agreementRealizationDate,
        ...otherValues
    } = values;

    const {
        vatRate,
        vatRateOther,
        ...otherAmount
    } = amount;

    let newVatRate = vatRate;
    let vatType = VatType.STANDARD;
    if (vatRate === SELECT_VALUE.OTHER) {
        newVatRate = vatRateOther
        vatType = VatType.OTHER;
    } else if (vatRate === SELECT_VALUE.CANCEL) {
        newVatRate = 0
        vatType = VatType.EXEMPTED
    } else if (vatRate === SELECT_VALUE.DIFFRENT_VAT) {
        newVatRate = 0
        vatType = VatType.MIXED
    }

    let newItems = items;
    if (newItems.length === 1) {
        const curName = items[0].name ? items[0].name.trim() : null;
        newItems = [{
            ...newItems[0],
            name: !curName ? name : curName
        }]
    }

    newItems = newItems.map(i => {
        let iNewVatRate = i.offerVatRate;
        let iVatType = VatType.STANDARD;
        if (i.offerVatRate === SELECT_VALUE.OTHER) {
            iNewVatRate = i.offerVatRateOther
            iVatType = VatType.OTHER;
        } else if (i.offerVatRate === SELECT_VALUE.CANCEL) {
            iNewVatRate = 0
            iVatType = VatType.EXEMPTED
        } else if (i.offerVatRate === SELECT_VALUE.DIFFRENT_VAT) {
            iNewVatRate = 0
            iVatType = VatType.MIXED
        } else if (i.offerVatRate === SELECT_VALUE.NOT_APPLICABLE) {
            iNewVatRate = 0
            iVatType = VatType.NOT_APPLICABLE
        } else if (i.offerVatRate === SELECT_VALUE.REVERSED) {
            iNewVatRate = 0
            iVatType = VatType.REVERSED
        }
        return {
            ...i,
            offerVatType: iVatType,
            offerVatValue: iNewVatRate
        }
    });

    const formatDate = (x) => (x ? x.format() : x);
    return {
        ...otherValues,
        name,
        agreementRealizationDate: {
            date: termOption === 'date' ? formatDate(termDate) : null,
            text: termOption === 'text' ? termDescription : null,
        },
        amount: {
            ...otherAmount,
            vatRate: newVatRate,
            vatType,
        },
        items: newItems
    }
}

const _formatFormValues = (values) => {
    const onlyTouchedAndNew = values.form.filter(
        element => element._touched || element.identity < 0
    )
    const formatedValues = onlyTouchedAndNew.reduce((prevValue, currValue) => {
        return [
            ...prevValue,
            _formatSinglePartValues(currValue)
        ]
    }, [])
    return formatedValues
}

const _getDeleteElements = (values) => {
    const {resources} = reduxStore.getState()
    const dealings = resources.dealingsList.dealings;

    return dealings.reduce((prev, curr) => {
        const id = curr.identity;
        const el = values.form.find(x => x.identity === id)
        if (!!el) return prev;
        return [
            ...prev,
            id
        ]
    }, [])
}

const _save = async (url, values, demandId) => {
    reduxStore.dispatch(setSaveStatusLoading());

    const dealingsToDelete = _getDeleteElements(values)
    const dealingsToSave = _formatFormValues(values)

    if (dealingsToSave.length <= 0 && dealingsToDelete.length <= 0) {
        reduxStore.dispatch(setSaveStatusDialog());
        return true;
    }

    const data = {
        dealingsToDelete,
        dealingsToSave,
    }

    try {
        let res = await RestRequestPOST(url, data)
        if (res.success) {
            reduxStore.dispatch(setSaveStatusDialog());
            return true;
        } else {
            let msg;
            if (res.errors) {
                if (dealingsToSave.some((d, i) => !!res.errors[`dealingsToSave[${i}].items`])) {
                    const dealingWithErrorId = dealingsToSave.filter((d, i) => !!res.errors[`dealingsToSave[${i}].items`]).map(d => d.identity)[0];
                    const dealingWithErrorIndex = dealingsToSave.map(d => d.identity).indexOf(dealingWithErrorId);
                    msg = res.errors[`dealingsToSave[${dealingWithErrorIndex}].items`];
                } else if (dealingsToSave.some((d, i) => !!res.errors[`dealingsToSave[${i}].stages[0].criterions`])) {
                    const dealingWithErrorId = dealingsToSave.filter((d, i) => !!res.errors[`dealingsToSave[${i}].stages[0].criterions`]).map(d => d.identity)[0];
                    const dealingWithErrorIndex = dealingsToSave.map(d => d.identity).indexOf(dealingWithErrorId);
                    msg = res.errors[`dealingsToSave[${dealingWithErrorIndex}].stages[0].criterions`];
                    if (msg === 'wrongWeightSum') {
                        msg = Tr('v_number_min_criteria', {min: 100});
                    }
                } else if (dealingsToSave.some((d, i) => !!res.errors[`dealingsToSave[${i}].amount.value`])) {
                    const dealingWithErrorId = dealingsToSave.filter((d, i) => !!res.errors[`dealingsToSave[${i}].amount.value`]).map(d => d.identity)[0];
                    const dealingWithErrorIndex = dealingsToSave.map(d => d.identity).indexOf(dealingWithErrorId);
                    msg = `${Tr('part')} ${dealingWithErrorIndex + 1}: ${res.errors[`dealingsToSave[${dealingWithErrorIndex}].amount.value`]}`;
                }
            }
            if (!msg) {
                msg = Tr('unknown_error_message');
            }
            reduxStore.dispatch(setSaveStatusError(msg));

        }
    } catch (error) {
    }
    return false;
}

const save = async (demandId, values) => {
    return await _save(Endpoints.DEALINGS_SAVE(demandId), values, demandId)
}

const validate = async (demandId) => {
    return RestRequestGET(Endpoints.DEALINGS_VALIDATE(demandId));
}

const checkForDraft = async (id, dealingId) => {
    return await RestRequestGET(Endpoints.DEALINGS_AUTOSAVE_CHECK(id, dealingId));
}

const loadDraft = async (id, dealingId) => {
    const res = await RestRequestGET(Endpoints.DEALINGS_AUTOSAVE(id, dealingId));
    if (res.success)
        res.result = _prepareIncomingDealing(res.result);
    return res;
}

const saveDraft = async (id, formValues) => {
    const dealingsToDelete = _getDeleteElements(formValues);
    const dealingsToSave = _formatFormValues(formValues);
    const data = {
        dealingsToDelete,
        dealingsToSave,
    }
    await RestRequestPOST(Endpoints.DEALINGS_AUTOSAVE_BATCH(id), data)
}

const deleteDraft = async (id) => {
    await RestRequestDELETE(Endpoints.DEALINGS_AUTOSAVE_BATCH(id));
}

const getRealizationValues = async (demandId) => {
    return await RestRequestGET(Endpoints.DEALING_REALIZATION_VALUE(demandId));
}
const saveRealizationValues = async (demandId, values, publishMode) => {
    return await RestRequestPOST(Endpoints.DEALING_REALIZATION_VALUE(demandId) + (publishMode != null ? '?publishMode=' + publishMode : ''), values);
}

const getFinalRealizationValues = async (demandId) => {
    return await RestRequestGET(Endpoints.DEALING_FINAL_REALIZATION_VALUE(demandId));
}
const saveFinalRealizationValues = async (demandId, values) => {
    return await RestRequestPOST(Endpoints.DEALING_FINAL_REALIZATION_VALUE(demandId), values);
}

const getRealizationValueStatus = async (demandId) => {
    const resp = await RestRequestGET(Endpoints.DEALING_REALIZATION_VALUE_STATUS(demandId));
    reduxStore.dispatch(setResource(RESOURCE_DEALING_REALIZATION_VALUE_STATUS, resp));
    return resp;
}

const publishRealizationAmountValue = async (demandId) => {
    await RestRequestPUT(Endpoints.DEALING_REALIZATION_VALUE_PUBLISH(demandId));
}

const unpublishRealizationAmountValue = async (demandId) => {
    await RestRequestPUT(Endpoints.DEALING_REALIZATION_VALUE_UNPUBLISH(demandId));
}

const RESOURCE_DEALING_REALIZATION_VALUE_STATUS = 'dealingsRealizationValueStatus';

export default {
    getList,
    get,
    save,
    checkForDraft,
    loadDraft,
    saveDraft,
    deleteDraft,
    clearResources,
    getDealingsMatchingCriterion,
    getDealingsMatchingCriterionName,
    getFullList,
    getRealizationValues,
    getFinalRealizationValues,
    getRealizationValueStatus,
    saveRealizationValues,
    saveFinalRealizationValues,
    publishRealizationAmountValue,
    unpublishRealizationAmountValue,
    validate,
    RESOURCE_DEALING_REALIZATION_VALUE_STATUS
}